import "../scss/events.scss";

//imported logic goes here

import navBarFunc from "./js-comps/navbar";
import translatorFunc from "./js-comps/translator";
import countDownTimer from "./js-comps/countdowntimer";
import gdprFunctionality from "./js-comps/gdpr";
import eventAniFunc from "./js-comps/eventPageAni";

navBarFunc();
countDownTimer("countdown-timer");
translatorFunc();
gdprFunctionality();
eventAniFunc();

//custom logic goes here
